<template>
  <a-form :form="parameterForm" class="parameterConfiguration">
    <div class="basicParameters">
      <a-button class="saveBtn" type="primary" :loading="btnLoading" @click="handleSubmit" v-if="$auth('deviceType.parameterSave')">保存</a-button>
      <div class="titleDiv">
        <div class="title">特性关联参数</div>
      </div>
      <a-row :gutter="12">
        <a-col :span="6" v-for="item in dataForm.peculiarityParamList" style="margin-bottom: 12px;">
          <a-input autocomplete="off" :disabled="true" v-model="item.name"/>
        </a-col>
      </a-row>
    </div>
    <div class="otherParameters">
      <div class="titleDiv">
        <div class="title">常规参数选择</div>
      </div>
      <a-row class="generalParameter">
        <a-col :span="6" v-for="(item2, index2) in generalList">
          <a-form-item :labelCol="labelColAll" :wrapperCol="wrapperColAll">
            <a-tree-select
              show-search
              :filterTreeNode="filterTreeNode"
              style="width: 100%"
              :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
              placeholder="请选择动设备参数"
              allow-clear
              tree-default-expand-all
              :treeData="generalParameterList"
              v-model="item2.equipmentParamTypeCode"
              :replaceFields="{
                title: 'name',
                key: 'key',
                value: 'code'
              }"
              @change="(value, label, extra) => changeEquipmentParamTypeCode(value, label, extra, item2, index2)"
            ></a-tree-select>
            <a-icon type="close-square" theme="filled"  class="delIcon" @click="del_general(item2, index2)"/>
          </a-form-item>
        </a-col>
        <a-col :span="6">
          <a-form-item :label-col="labelColAll" :wrapper-col="wrapperColAll">
            <a-button block type="dashed" icon="plus" @click="add_general" class="addBtn_general">添加</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </div>
<!--    <div class="otherParameters2">-->
<!--      <div class="titleDiv">-->
<!--        <div class="title">自定义参数</div>-->
<!--      </div>-->
<!--      <div class="other-data">-->
<!--        <a-row :gutter="10" class="item-label">-->
<!--          <a-col :span="4" class="fontWeight">参数名称</a-col>-->
<!--          <a-col :span="4" class="fontWeight">是否必填</a-col>-->
<!--          <a-col :span="4" class="fontWeight">参数状态:在用/失效</a-col>-->
<!--          <a-col :span="12">-->
<!--            <span class="fontWeight">填写类型</span>-->
<!--            <a-icon type="info-circle" theme="filled" />-->
<!--            <span class="anticonTooltip">选择单选时，用顿号分隔每个项点，如：A、B、C、D</span>-->
<!--          </a-col>-->
<!--        </a-row>-->
<!--        <div class="dataInputDiv">-->
<!--          <a-row v-for="(item, index) in otherData" :key="index" :gutter="10" class="item-data">-->
<!--            <a-col :span="4">-->
<!--              <a-input v-model="item.name" placeholder="请输入参数名称"/>-->
<!--            </a-col>-->
<!--            <a-col :span="4">-->
<!--              <a-select v-model="item.requiredState" placeholder="请选择是否必填" style="width: 100%">-->
<!--                <a-select-option :value="1">是</a-select-option>-->
<!--                <a-select-option :value="0">否</a-select-option>-->
<!--              </a-select>-->
<!--            </a-col>-->
<!--            <a-col :span="4">-->
<!--              <a-select v-model="item.status" placeholder="请选择参数状态" style="width: 100%" @change="changeStatus(item)">-->
<!--                <a-select-option :value="1">在用</a-select-option>-->
<!--                <a-select-option :value="2">失效</a-select-option>-->
<!--              </a-select>-->
<!--            </a-col>-->
<!--            <a-col :span="12">-->
<!--              <a-col :span="3">-->
<!--                <a-select v-model="item.valueType" placeholder="请选择" style="width: 100%" @change="delete item.valueOptions">-->
<!--                  <a-select-option :value="1">填空</a-select-option>-->
<!--                  <a-select-option :value="2">单选</a-select-option>-->
<!--                </a-select>-->
<!--              </a-col>-->
<!--              <a-col :span="21">-->
<!--                <a-input :disabled="item.valueType === 1" v-model="item.valueOptions" placeholder="请输入" class="inputType"></a-input>-->
<!--                <a-icon type="close-square" @click="del_other(item, index)" />-->
<!--              </a-col>-->
<!--            </a-col>-->
<!--          </a-row>-->
<!--        </div>-->
<!--      </div>-->
<!--      <a-button block type="dashed" icon="plus" @click="add_other" class="addBtn_general">添加</a-button>-->
<!--    </div>-->
  </a-form>
</template>

<script>
import {
  addDeviceType,
  addParam, checkFidleDelete, checkFieldDeleteByType,
  checkParam,
  checkTypeParam, checkTypeParamIsUse, deleteCheckParam,
  editDeviceType,
  getDeviceTypeInfo
} from '@/api/deviceType'
import { getTreeDeviceType } from '@/api/deviceParameter'

export default {
  name: 'ParameterConfiguration',
  props: ['dataForm'],
  computed: {
    deviceTypeStatus () {
      return this.$store.state.deviceType.deviceTypeStatus
    }
  },
  data () {
    return {
      parameterForm: this.$form.createForm(this, { name: 'featureConfiguration' }),
      labelColAll: {
        xs: { span: 24 },
        sm: { span: 0 }
      },
      wrapperColAll: {
        xs: { span: 24 },
        sm: { span: 24 }
      },
      btnLoading: false,
      type: 'edit',
      // 常规参数选择列表
      generalList: [],
      generalVerifyList: [], // 验证
      generalDelList: [],
      // 常规参数列表
      generalParameterList: [],
      // 其他参数列表
      // otherData: [],
      originalOtherData: [],
      otherDataDelList: []
    }
  },
  // watch: {
  //   deviceTypeStatus: {
  //     handler (newVal) {
  //       switch (newVal.type) {
  //         case 'edit':
  //           this.type = 'edit'
  //           this.getDeviceTypeInfo({ id: newVal.data.id, pName: newVal.data.pName })
  //           break
  //         case 'rootAdd':
  //           this.type = 'add'
  //           this.dataForm = {}
  //           this.initTableData(newVal.data)
  //           break
  //         case 'childAdd':
  //           this.type = 'add'
  //           this.dataForm = {}
  //           this.initTableData(newVal.data)
  //           break
  //       }
  //     },
  //     deep: true
  //   }
  // },
  created () {
  },
  mounted () {
  },
  methods: {
    // 获取表单数据
    async getDeviceTypeInfo (info) {
      this.$emit('setSpinning', true)
      this.spinning = true
      const res = await getDeviceTypeInfo(info.id)
      if (res.status === 0) {
        this.dataForm = res.data
        this.initTableData({ ...res.data })
      } else {
        this.$message.error(res.info.message)
      }
      this.$emit('setSpinning', false)
    },
    // 设置表单
    async initTableData (info) {
      this.generalDelList = []
      this.otherDataDelList = []
      this.generalList = JSON.parse(JSON.stringify(info.paramList))
      this.generalVerifyList = JSON.parse(JSON.stringify(info.paramList))
      // this.otherData = JSON.parse(JSON.stringify(info.typeParamList))
      this.originalOtherData = JSON.parse(JSON.stringify(info.typeParamList))
      await this.getGeneralParameterList()
    },
    setType (type) {
      this.type = type
    },
    // 获取常规参数列表
    getGeneralParameterList () {
      function setChildrenNotChange (arr, code) {
        arr.forEach(item => {
          if (item.code === code) {
            item.canNotChange = true
            item.disabled = true
            if (item.children) {
              setChildrenNotChange(item.children, code)
            }
          }
        })
      }
      const data = {
        pCode: 'EQUIPMENT_PARAM'
      }
      getTreeDeviceType(data).then(res => {
        if (res.status === 0) {
          this.dataForm.peculiarityParamList.forEach(item => {
            res.data.forEach(i => {
              if (i.code === item.code) {
                i.canNotChange = true
                i.disabled = true
              }
              if (i.children) {
                setChildrenNotChange(i.children, item.code)
              }
            })
          })
          this.generalParameterList = res.data
          this.findGeneral()
        } else {
          this.$message.error(res.info.message)
        }
      })
    },
    // 常规参数，找到传入的元素，并且给他复制disabled状态
    findGeneral () {
      const arr = this.generalList.map(item => {
        return item.equipmentParamTypeCode
      })
      function findChildren (data) {
        for (let i = 0; i < data.length; i++) {
          const j = data[i]
          if (!j.canNotChange) {
            if (arr.indexOf(j.code) >= 0) {
              j.disabled = true
            } else {
              j.disabled = false
            }
          }
          if (j.children) {
            findChildren(j.children)
          }
        }
      }
      for (let i = 0; i < this.generalParameterList.length; i++) {
        const j = this.generalParameterList[i]
        if (!j.canNotChange) {
          if (arr.indexOf(j.code) >= 0) {
            j.disabled = true
          } else {
            j.disabled = false
          }
        }
        if (j.children) {
          findChildren(j.children)
        }
      }
      this.$forceUpdate()
    },
    // 增加常规参数
    add_general () {
      this.generalList.push({
        equipmentParamTypeCode: undefined
      })
      this.generalVerifyList.push({
        equipmentParamTypeCode: undefined
      })
    },
    // 判断删除常规参数是否需要提示_常规参数
    async whetherToPrompt_routine (item, index, type, value) {
      const that = this
      const params = {
        code: this.deviceTypeStatus.data.code,
        typeCode: item.equipmentParamTypeCode
      }
      deleteCheckParam(params).then(res => {
        if (res.status === 0) {
          if (res.data.state === 'SUCCESS') {
            this.$confirm({
              title: (h) => {
                return h('div', {
                  domProps: {
                    innerHTML: res.data.msg
                  }
                })
              },
              okText: '确定',
              okType: 'danger',
              cancelText: '取消',
              onOk () {
                if (type === 'edit') {
                  that.generalVerifyList[index].equipmentParamTypeCode = value
                  that.findGeneral()
                } else {
                  that.delGeneral(item, index)
                }
              },
              onCancel () {
                if (type === 'edit') {
                  that.generalList[index].equipmentParamTypeCode = that.generalVerifyList[index].equipmentParamTypeCode
                  that.findGeneral()
                }
              }
            })
          } else {
            this.$message.error(res.data.msg)
            if (type === 'edit') {
              that.generalList[index].equipmentParamTypeCode = that.generalVerifyList[index].equipmentParamTypeCode
              that.findGeneral()
            }
          }
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
      // const params1 = {
      //   dataIndex: item.equipmentParamTypeCode,
      //   type: 2,
      //   typeCode: this.deviceTypeStatus.data.code
      // }
      // const params2 = {
      //   typeCode: item.equipmentParamTypeCode,
      //   typeId: this.deviceTypeStatus.data.id
      // }
      // const that = this
      // await checkFieldDeleteByType(params1).then(res => {
      //   if (res.status === 0) {
      //     if (res.data) {
      //       if (type === 'edit') {
      //         this.$message.error('该参数已被使用，无法修改')
      //         that.generalList[index].equipmentParamTypeCode = that.generalVerifyList[index].equipmentParamTypeCode
      //         that.findGeneral()
      //       } else {
      //         this.$message.error('该参数已被使用，无法删除')
      //       }
      //     } else {
      //       checkParam(params2).then(res => {
      //         if (res.status === 0) {
      //           if (res.data) {
      //             if (type === 'edit') {
      //               this.$confirm({
      //                 title: '是否确定修改',
      //                 okText: '确定',
      //                 okType: 'danger',
      //                 cancelText: '取消',
      //                 onOk () {
      //                   that.generalVerifyList[index].equipmentParamTypeCode = value
      //                   that.findGeneral()
      //                 },
      //                 onCancel () {
      //                   that.generalList[index].equipmentParamTypeCode = that.generalVerifyList[index].equipmentParamTypeCode
      //                   that.findGeneral()
      //                 }
      //               })
      //             } else {
      //               this.showDeleteConfirm(item, index, this.delGeneral)
      //             }
      //           } else {
      //             if (type === 'edit') {
      //               that.generalVerifyList[index].equipmentParamTypeCode = value
      //               that.findGeneral()
      //             } else {
      //               this.delGeneral(item, index)
      //             }
      //           }
      //         } else {
      //           this.$message.error(res.info.message)
      //         }
      //       }).catch(err => {
      //         this.$message.error(err.info.message)
      //       })
      //     }
      //   } else {
      //     this.$message.error(res.info.message)
      //   }
      // }).catch(err => {
      //   this.$message.error(err.info.message)
      // })
    },
    // 判断删除常规参数
    async del_general (item, index) {
      if (item.equipmentTypeId) {
        await this.whetherToPrompt_routine(item, index)
      } else {
        this.generalList.splice(index, 1)
        this.generalVerifyList.splice(index, 1)
        this.findGeneral()
      }
    },
    // 删除常规参数
    delGeneral (item, index) {
      this.generalList.splice(index, 1)
      this.generalVerifyList.splice(index, 1)
      this.findGeneral()
    },
    // 改变常规参数选择
    async changeEquipmentParamTypeCode (value, label, extra, data, index) {
      const that = this
      if (data.equipmentTypeId) {
        await this.whetherToPrompt_routine(this.generalVerifyList[index], index, 'edit', value)
      }
      this.findGeneral()
    },
    // 常规参数树搜索
    filterTreeNode (inputValue, treeNode) {
      return treeNode.componentOptions.propsData.dataRef.name.indexOf(inputValue) > -1
    },
    // 增加其他参数
    add_other () {
      this.otherData.push({
        'name': '',
        'requiredState': undefined,
        'status': undefined,
        'valueType': undefined,
        'valueOptions': ''
      })
      this.originalOtherData.push({
        'name': '',
        'requiredState': undefined,
        'status': undefined,
        'valueType': undefined,
        'valueOptions': ''
      })
      const div = document.getElementsByClassName('parameterConfiguration')[0]
      this.$nextTick(() => {
        div.scrollTop = div.scrollHeight
      })
    },
    // 判断删除常规参数是否需要提示_自定义参数
    async whetherToPrompt_customize (item, index) {
      const params1 = {
        dataIndex: item.id,
        type: 3,
        typeCode: this.deviceTypeStatus.data.code
      }
      const params2 = {
        typeParamId: item.id,
        typeId: this.deviceTypeStatus.data.id
      }
      await checkFieldDeleteByType(params1).then(res => {
        if (res.status === 0) {
          if (res.data) {
            this.$message.error('该参数已被使用，无法删除')
          } else {
            checkTypeParam(params2).then(res => {
              if (res.status === 0) {
                if (res.data) {
                  this.showDeleteConfirm(item, index, this.delOther)
                } else {
                  this.delOther(item, index)
                }
              } else {
                this.$message.error(res.info.message)
              }
            }).catch(err => {
              this.$message.error(err.info.message)
            })
          }
        } else {
          this.$message.error(res.info.message)
        }
      }).catch(err => {
        this.$message.error(err.info.message)
      })
    },
    // 判断删除其他参数
    async del_other (item, index) {
      if (item.id) {
        // 调确认接口
        this.whetherToPrompt_customize(item, index)
        // if (await this.whetherToPrompt_customize(item, index)) {
        //   this.showDeleteConfirm(item, index, this.delOther)
        // } else {
        //   this.delOther(item, index)
        // }
      } else {
        this.otherData.splice(index, 1)
        this.originalOtherData.splice(index, 1)
      }
    },
    // 删除其他参数
    delOther (item, index) {
      const delData = { ...item }
      delData.status = 9
      this.otherDataDelList.push(delData)
      this.otherData.splice(index, 1)
      this.originalOtherData.splice(index, 1)
    },
    // 删除二次确认
    showDeleteConfirm (item, index, delFun) {
      this.$confirm({
        title: '字段删除后，对应的设备中的字段数据将丢失，确定删除么？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          delFun(item, index)
        },
        onCancel () {
          console.log('Cancel')
        }
      })
    },
    // 改变自定义参数状态
    changeStatus (data) {
      if (data.id) {
        const params = {
          dataIndex: data.id,
          type: 3,
          typeCode: this.deviceTypeStatus.data.code
        }
        checkFieldDeleteByType(params).then(res => {
          if (res.status === 0) {
            if (res.data) {
              this.$message.error('该参数已被使用，无法修改状态')
              const index = this.originalOtherData.findIndex(item => item.id === data.id)
              data.status = this.originalOtherData[index].status
            }
          } else {
            this.$message.error(res.info.message)
          }
        }).catch(err => {
          this.$message.error(err.info.message)
        })
      }
    },
    // 参数设置保存
    handleSubmit () {
      this.parameterForm.validateFieldsAndScroll(async (err, value) => {
        if (!err) {
          this.btnLoading = true
          const paramList = []
          const typeParamList = []
          try {
            this.generalList.forEach(item => {
              if (item.equipmentParamTypeCode) {
                const data = {
                  equipmentParamTypeCode: item.equipmentParamTypeCode,
                  equipmentTypeCode: this.deviceTypeStatus.data.code,
                  equipmentTypeId: this.deviceTypeStatus.data.id
                }
                paramList.push(data)
              } else {
                throw new Error()
              }
            })
          } catch (error) {
            this.$message.error('常规参数不能为空')
            this.btnLoading = false
            return
          }
          const params = {
            id: this.deviceTypeStatus.data.id,
            code: this.deviceTypeStatus.data.code,
            paramList: paramList
          }
          addParam(params).then(res => {
            if (res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('getTabData', {
                id: res.data,
                typeId: res.data,
                typeCode: this.deviceTypeStatus.data.code
              })
              this.btnLoading = false
            } else {
              this.$message.error(res.info.message)
              this.btnLoading = false
            }
          }).catch(err => {
            this.$message.error(err.info.message)
            this.btnLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.parameterConfiguration {
  height: calc(100% - 45px);
  overflow-y: auto;
  overflow-x: hidden;
  border-top: 1px solid #DDDDDD;
  padding-top: 11px;
  .saveBtn {
    margin-bottom: 12px;
  }
}
.titleDiv {
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  .title{
    border-left: 4px solid #08409F;
    padding-left: 8px;
    color: #08409F;
  }
}
.otherParameters {
  margin-top: 8px;
  margin-bottom: 8px;
  .generalParameter {
    /deep/.ant-col-6 {
      padding-left: 12px;
      .ant-form-item-children {
        display: flex;
        flex-direction: row;
        align-items: center;
        .ant-select {
          width: calc(100% - 28px);
          margin-right: 8px;
        }
        .delIcon {
          font-size: 20px;
          color: red;
        }
      }
    }
  }
}
.addBtn_general {
  width: 100%;
  /deep/.anticon {
    color: #1791FF;
  }
}
.other-data{
  position: relative;
  height: calc(100% - 44px);
  .action-btn{
    position: absolute;
    right: 10px;
    top: -36px;
    display: flex;
    .btn{
      margin-left: 10px;
    }
  }
  .item-label{
    margin: 0 0 12px 0 !important;
    background: #F5F5F5;
    .ant-col {
      padding: 10px 8px;
      border-top: 1px solid #DDDDDD;
      border-bottom: 1px solid #DDDDDD;
      border-right: 1px solid #DDDDDD;
    }
    .ant-col:nth-child(1) {
      border-left: 1px solid #DDDDDD;
    }
    .anticon{
      color: #1791FF;
      font-size: 14px;
      margin-left: 9px;
      margin-right: 9px;
    }
    .anticonTooltip{
      color: #1791FF;
      font-size: 12px;
    }
  }
  .dataInputDiv {
    height: calc(100% - 70px);
    /deep/.ant-col {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .inputType {
      width: calc(100% - 32px);
      margin-right: 12px;
    }
  }
  .item-data{
    width: 100%;
    margin-bottom: 12px;
    .anticon{
      color: #E73B3B;
      font-size: 20px;
    }
  }
}
.fontWeight {
  font-weight: bold;
}
/deep/.ant-modal-confirm-title {
  font-weight: bold;
  font-size: 16px;
}
</style>
